import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { ReleasesType } from "../../types";

type ReleaseState = {
  selectedRelease: {
    id: number | null;
    item: ReleasesType.ReleasePartial | null;
  };
};
const initial: ReleaseState = { selectedRelease: { id: null, item: null } };

export const releaseSlice = createSlice({
  name: "release",
  initialState: initial as ReleaseState,
  reducers: {
    setSelectedRelease(
      state: ReleaseState,
      action: PayloadAction<ReleaseState["selectedRelease"]>
    ) {
      state.selectedRelease = action.payload;
    },
    clearSelectedRelease(state: ReleaseState) {
      state.selectedRelease = { id: null, item: null };
    },
  },
});

export const { setSelectedRelease, clearSelectedRelease } =
  releaseSlice.actions;
export const releaseReducer = releaseSlice.reducer;
